import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { TicketPriority } from '@/services/TicketsService';

const SLA_PRIORITY_ORDER: TicketPriority[] = ['critical', 'high', 'low'];

interface SlaCardProps {
  title: string;
  description: string;
  severityHeader: string;
  responseHeader: string;
  priorityLabels: Record<TicketPriority, string>;
  responseByPriority: Record<TicketPriority, string>;
}

export function SlaCard({
  title,
  description,
  severityHeader,
  responseHeader,
  priorityLabels,
  responseByPriority,
}: SlaCardProps) {
  return (
    <Card>
      <CardHeader className="space-y-2">
        <CardTitle className="text-base">{title}</CardTitle>
        <p className="text-sm text-gray-600">{description}</p>
      </CardHeader>
      <CardContent>
        <div className="overflow-hidden rounded-md border border-gray-800">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-800 px-3 py-2 text-left font-semibold">
                  {severityHeader}
                </th>
                <th className="border border-gray-800 px-3 py-2 text-left font-semibold">
                  {responseHeader}
                </th>
              </tr>
            </thead>
            <tbody>
              {SLA_PRIORITY_ORDER.map((priority) => (
                <tr key={priority}>
                  <td className="border border-gray-800 px-3 py-2">
                    {priorityLabels[priority]}
                  </td>
                  <td className="border border-gray-800 px-3 py-2">
                    {responseByPriority[priority]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
